import React from 'react';

import ArticleIcon from '@mui/icons-material/Article';
import CampaignIcon from '@mui/icons-material/Campaign';
import ChecklistIcon from '@mui/icons-material/Checklist';
import DescriptionIcon from '@mui/icons-material/Description';
import EventNoteIcon from '@mui/icons-material/EventNote';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import GavelIcon from '@mui/icons-material/Gavel';
import HandshakeIcon from '@mui/icons-material/Handshake';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PaymentsIcon from '@mui/icons-material/Payments';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

const WORKFLOW_ITEMS = [
  { label: 'Hotel Proposal Pricing Tool', icon: PaymentsIcon },
  { label: 'Assets', icon: FolderOpenIcon },
  { label: 'Deal Information', icon: DescriptionIcon },
  { label: 'Rates and Inventory', icon: EventNoteIcon },
  { label: 'Tasks & Activity', icon: TaskAltIcon },
  { label: 'Marketing Assets', icon: CampaignIcon },
  { label: 'Contracts', icon: GavelIcon },
  { label: 'Partner Information', icon: HandshakeIcon },
  { label: 'CM Checklist', icon: ChecklistIcon },
  { label: 'Content', icon: ArticleIcon, active: true },
];

interface Props {
  hotelCode?: string;
  hotelName: string;
  location: string;
}

export default function OfferBuilderSidebar({ hotelCode, hotelName, location }: Props) {
  return (
    <Paper
      square
      variant="outlined"
      sx={{
        display: { xs: 'none', lg: 'block' },
        minHeight: '100vh',
        borderTop: 0,
        borderBottom: 0,
        borderLeft: 0,
        px: 3,
        py: 2.5,
      }}
    >
      <Box sx={{ pb: 2, mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="subtitle1" fontWeight={600}>
          {hotelName}
        </Typography>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ color: 'text.secondary', mt: 1 }}>
          <LocationOnIcon fontSize="small" />
          <Typography variant="body2">{location}</Typography>
        </Stack>
        {hotelCode && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, overflowWrap: 'anywhere' }}>
            {hotelCode}
          </Typography>
        )}
      </Box>

      <Typography variant="overline" color="text.secondary">
        Hotel proposal
      </Typography>
      <Stack component="nav" spacing={0.5} sx={{ mt: 1 }}>
        {WORKFLOW_ITEMS.map(({ label, icon: Icon, active }) => (
          <Button
            key={label}
            startIcon={<Icon />}
            variant={active ? 'contained' : 'text'}
            color="primary"
            fullWidth
            sx={{ justifyContent: 'flex-start', textTransform: 'none' }}
          >
            {label}
          </Button>
        ))}
      </Stack>
    </Paper>
  );
}
